"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gaEvents = void 0;
const utils_1 = require("./utils");
const utils_common_is_webview_1 = __importDefault(require("@gcloud-npm/utils.common.is-webview"));
const utils_common_is_colapp_1 = __importDefault(require("@gcloud-npm/utils.common.is-colapp"));
const utils_metrics_send_ga_page_event_1 = __importDefault(require("@gcloud-npm/utils.metrics.send-ga-page-event"));
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const TERMINAL_R2R_INCLUIDO = 'TERMINAL_R2R_INCLUIDO';
const normalizeZipCode = (zipcode) => {
    let res = "";
    if (zipcode === "ZR")
        res = "regulada";
    if (zipcode === "ZL")
        res = "libre";
    if (zipcode === "ZM")
        res = "mixta";
    return res;
};
const isUserLoggedIn = (context) => {
    let res = false;
    if (context) {
        res =
            context.userIdPartyHash ||
                context.userCUCFijoHash ||
                context.userCUCMovilHash ||
                context.userCUCPrepagoHash;
    }
    return res;
};
/**
 * Envio a GA sobre info el usuario según valor de cookies
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
const sendGaConfig = ({ context, shouldSendHash, setContextData }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const isWebviewBool = (0, utils_common_is_webview_1.default)();
    const isColAppBool = (0, utils_common_is_colapp_1.default)();
    const data = (0, utils_1.createPageEventObject)(context);
    const secureCookieStorageLib = new utils_secure_local_storage_1.default();
    const persistedInfo = secureCookieStorageLib.getItem("ts");
    const { userIdPartyHashFromGetEg, userPo } = persistedInfo;
    const mainProperties = (0, utils_1.extractMainProperties)(data, isWebviewBool, isColAppBool);
    const userProperties = (0, utils_1.extractUserProperties)(data, shouldSendHash, userIdPartyHashFromGetEg);
    const zipcode = normalizeZipCode(((_a = persistedInfo === null || persistedInfo === void 0 ? void 0 : persistedInfo.geo) === null || _a === void 0 ? void 0 : _a.zone) || "");
    const logado = isUserLoggedIn(context);
    const normalizeEg = (0, utils_1.normalizeUserEg)(persistedInfo);
    const finalUserPo = userPo ? JSON.stringify(userPo) : "";
    /* ------------------------ extraemos info del secure ----------------------- */
    let x = "";
    let mobile = null;
    if (persistedInfo && persistedInfo.geo && persistedInfo.geo.x) {
        ({ x } = persistedInfo.geo);
    }
    if (persistedInfo && persistedInfo.geo && persistedInfo.geo.mobile !== 'undefined') {
        ({ mobile } = persistedInfo.geo);
    }
    let user_r2r_renovation = false;
    if (persistedInfo &&
        persistedInfo.userCompatibilities &&
        persistedInfo.userCompatibilities.r2r &&
        persistedInfo.userCompatibilities.r2r &&
        persistedInfo.userCompatibilities.r2r.hiredR2R &&
        Array.isArray(persistedInfo.userCompatibilities.r2r.hiredR2R)) {
        user_r2r_renovation = false;
        persistedInfo.userCompatibilities.r2r.hiredR2R.forEach(hiredElement => {
            if (!user_r2r_renovation) {
                const { hasMobileInsurance, productOfferingType, leasing } = hiredElement;
                const { isCancellable } = leasing;
                const hasProperType = productOfferingType === TERMINAL_R2R_INCLUIDO;
                user_r2r_renovation = hasProperType && isCancellable && !hasMobileInsurance;
            }
        });
    }
    let send_page_view = true;
    // evitamos que google envia page view por su cuenta en areaprivada que hay spa
    try {
        let prefix = '';
        const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
        switch (currentEnv) {
            case 'dev_ssr':
                prefix = '/develop';
                break;
            case 'qa_ssr':
                prefix = '/qa';
                break;
            default:
                prefix = '';
                break;
        }
        const spaPath = `${prefix}/area-cliente/`;
        const { pathname } = document.location;
        if (pathname.indexOf(spaPath) === 0 &&
            pathname !== `${spaPath}mi-cuenta/` &&
            pathname !== `${spaPath}movistar-por-ti/`) {
            send_page_view = false;
        }
    }
    catch (e) {
        console.error(e);
    }
    try {
        const page_variation = logado ? "cliente" : "no-cliente";
        gtag("config", `${process.env.NEXT_PUBLIC_GTM_ID}`, Object.assign(Object.assign(Object.assign(Object.assign({ page_variation, transport_url: "https://metrics.col.movistar.es", user_r2r_renovation, first_party_collection: true, send_page_view }, mainProperties), userProperties), { 'user_x': x, 'user_mobile_network': mobile, "zip-code": zipcode, user_po: finalUserPo }), normalizeEg));
        /* ------------------- mandamos pageview para los webview ------------------- */
        if (isWebviewBool || isColAppBool) {
            let retries = 10;
            let waitWB = setInterval(() => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    retries--;
                    const currentPageName = mainProperties && mainProperties['page_name'];
                    if (window && window.webviewBridge && window.webviewBridge.setScreenName) {
                        window.webviewBridge.setScreenName(currentPageName);
                    }
                    if (window && window.manhattanBridge && window.manhattanBridge.logEvent) {
                        // window.manhattanBridge.setScreen(currentPageName);     
                        window.manhattanBridge.logEvent("screen_view", {
                            screen_name: currentPageName,
                            screen_class: currentPageName,
                            is_webView: 1,
                        });
                    }
                    retries = -1;
                    if (retries < 0) {
                        clearInterval(waitWB);
                    }
                }
                catch (e) { }
            }), 100);
        }
        /* ------ intentamos bindear al contexto de redux la session id de ga4 ------ */
        gtag("get", "G-J1GJWFY08P", "session_id", (sessionId) => {
            if (context && context.clientIDs) {
                context.clientIDs.sessionId = sessionId;
                setContextData(context);
            }
        });
        // Envia a GA el evento page_printed una vez ya tiene toda la info
        (0, utils_metrics_send_ga_page_event_1.default)("", Object.assign(Object.assign({}, mainProperties), { page_variation }));
    }
    catch (e) {
        console.log(e);
    }
});
/**
 * Actualiza si el cliente ha aceptado las cookies.
 * @returns {boolean} - true si han transcurrido seis meses, false si no.
 */
const gaEvents = ({ context, setContextData, ad_storage, analytics_storage, ad_user_data, ad_personalization, }) => __awaiter(void 0, void 0, void 0, function* () {
    const shouldSendHash = ad_storage === "granted" && analytics_storage === "granted";
    if (ad_storage !== "denied" || analytics_storage !== "denied") {
        try {
            gtag("consent", "update", {
                ad_storage,
                analytics_storage,
                ad_user_data,
                ad_personalization,
            });
        }
        catch (e) {
            console.log(e);
        }
    }
    sendGaConfig({ context, shouldSendHash, setContextData });
});
exports.gaEvents = gaEvents;
exports.default = exports.gaEvents;
//# sourceMappingURL=index.js.map